export default "__VITE_PUBLIC_ASSET__30c97d42__"